import React, { useState } from 'react';
import { Link } from "react-router-dom";
import * as Element from "./style";
import twitterIcon from '../../assets/images/assets/twitter_icon.png';
import telegram from '../../assets/images/assets/telegram.png';
import opensea from '../../assets/images/assets/opensea.png';
import dextools from '../../assets/images/assets/dex-tools.png';
import AppStore from '../../assets/images/assets/Untitled design (1).png';
import Android  from '../../assets/images/assets/andriod.png';

import Logo from "../../assets/images/assets/owner.png";

import { useAccount, useDisconnect, useEnsName } from 'wagmi'
import { shorter } from '../../utils';
import { connectorLocalStorageKey } from '../../utils/connectors';

function Header(props) {
  const { connectAccount } = props;

  const { address, isConnected } = useAccount();
  const { data: ensName } = useEnsName({ address });
  
  const [showDropDown, setShowDropDown] = useState(false);

  const { disconnect } = useDisconnect()

  function signOut() {
    disconnect();
    window.localStorage.setItem(connectorLocalStorageKey, "");
  }

  return (
    <Element.Header>
      <Element.Container>
        <Element.HeaderContent>
        <Element.Logo>
                        <Link to="/">
                            <div className='img-content'>
                                <img src={Logo} alt='MYC Logo' />
                            </div>
                        </Link>

                        {/* Social Icons */}
                        <Element.SocialIcons>
                            <a href="https://twitter.com/MYC_TOKEN" target="_blank" rel="noopener noreferrer">
                                <img src={twitterIcon} alt="Twitter" />
                            </a>
                            <a href="https://t.me/MYCTOKEN" target="_blank" rel="noopener noreferrer">
                                <img src={telegram} alt="Telegram" />
                            </a>
                            <a href="https://opensea.io/collection/executives-of-club-33" target="_blank" rel="noopener noreferrer">
                                <img src={opensea} alt="OpenSea" />
                            </a>
                            <a href="https://www.dextools.io/app/en/ether/pair-explorer/0xf6e14072490f5882b04d9dd5bc15dbb97133a38e" target="_blank" rel="noopener noreferrer">
                                <img src={dextools} alt="Dex Tools" />
                            </a>
                            <a href="https://apps.apple.com/us/app/odd-app/id1636319934" target="_blank" rel="noopener noreferrer">
                                <img src={AppStore} alt="Apple Store" />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.mycodd.app" target="_blank" rel="noopener noreferrer">
                                <img src={Android} alt="Andriod Play Store" />
                            </a>
                        </Element.SocialIcons>
                    </Element.Logo>
                    <h1 className="h1">Mega Yacht Cult <i>NFT MINT</i>, <i>ODD APP</i> & <i>ERC20 Token</i></h1>

          <Element.ConnectWrapper>
            {
              isConnected ?
                <Element.ButtonContainer>
                  <div className='header-btn' onClick={() => {
                      setShowDropDown(!showDropDown);
                    }}>
                    <p>
                    {ensName ?? shorter(address)}                     
                    </p>
                    <i className='icon-angle'></i>
                  </div>
                </Element.ButtonContainer>
                :
                <Element.ButtonContainer>
                  <div className='header-btn' onClick={() => { connectAccount() }}>
                    Connect
                  </div>
                </Element.ButtonContainer>
            }
            {
              isConnected && showDropDown &&
              (
                <Element.HeaderCenter>
                  <Element.DropDownMenus>
                    <Element.DropDownMenu
                      onClick={() => {
                        signOut();
                        setShowDropDown(false);
                      }}>
                      Disconnect
                    </Element.DropDownMenu>
                  </Element.DropDownMenus>
                </Element.HeaderCenter>
              )
            }
          </Element.ConnectWrapper>
        </Element.HeaderContent>
      </Element.Container>
    </Element.Header>
  );
}

export default Header;
